import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  display: block;

  padding: 0;
  border: 0;
  line-height: 0;
  outline-offset: 0;

  appearance: none;
  background: none;

  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`;

type ClickableButtonWrapperProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "type"
>;

function ClickableButtonWrapper(buttonProps: ClickableButtonWrapperProps) {
  return <StyledButton type="button" {...buttonProps} />;
}

export default ClickableButtonWrapper;
